export default {
  name: 'dicom-plus-modal-tab-complementares',
  inject: ['dicomPlusModal'],
  computed: {
    m() {
      return this.dicomPlusModal
    }
  }
}
